import React from 'react';

import { Sparkles } from '@videoblocks/react-icons';

import { Button } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import { Text } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Text/Text';

interface AIPromptInputProps {
  prompt: string;
  onPromptChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onGenerateVideo: () => void;
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
}

const AIPromptInput: React.FC<AIPromptInputProps> = ({
  prompt = '',
  onPromptChange,
  onGenerateVideo,
  suggestions = [],
  onSuggestionClick,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onGenerateVideo();
    }
  };

  return (
    <div className="w-full bg-gray-900 border-2 border-gray-700 rounded-lg text-white mb-6">
      <div className="p-4">
        <textarea
          value={prompt}
          onChange={onPromptChange}
          placeholder="Describe the video you want to create..."
          className="w-full bg-transparent border-0 resize-none outline-none placeholder-white text-sm"
          onKeyDown={handleKeyDown}
          rows={3}
          aria-label="Describe the video you want to create"
        />
        <div className="flex justify-end gap-3">
          <Button variant="outlined-light">24 credits available</Button>
          <Button onClick={onGenerateVideo}>Generate Video</Button>
        </div>
      </div>

      {/* Suggestions Section */}
      <div className="flex flex-wrap gap-2 border-t border-gray-700 p-4 items-center">
        <Sparkles className="w-4 h-4 fill-white" />
        <Text fontSize="xs" className="text-white m-0">
          Suggestions:
        </Text>
        {suggestions.length > 0 ? (
          suggestions.map((suggestion, index) => (
            <button
              key={`suggestion-${index}`}
              type="button"
              onClick={() => onSuggestionClick(suggestion)}
              className="bg-white text-gray-900 px-3 py-1.5 rounded-full text-xs transition-all hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
              aria-label={`Use suggestion: ${suggestion}`}
            >
              {suggestion}
            </button>
          ))
        ) : (
          <Text fontSize="xs" className="text-gray-400 italic">
            No suggestions available
          </Text>
        )}
      </div>
    </div>
  );
};

export default AIPromptInput;
